// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"1befb021","482":"e306bf32","488":"426f8acf"}[chunkId] + ".chunk.js";
};